import React, { useState } from 'react';
import '../styles/AdminResetPassword.css';

const AdminResetPassword = () => {
  const [username, setUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      const response = await fetch('/api/auth/admin-reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, newPassword }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message || 'Password reset successful.');
      } else {
        setError(data.error || 'Reset failed.');
      }
    } catch (err) {
      setError('Server error.');
    }
  };

  return (
    <div className="admin-reset-password-container">
      <h2>Admin Password Reset</h2>
      <form onSubmit={handleSubmit}>
        <label>Username:
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
        </label>
        <label>New Password:
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
            minLength={6}
          />
        </label>
        <button type="submit">Reset Password</button>
      </form>
      {message && <div className="success-message">{message}</div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default AdminResetPassword;